import { initAppLauncher } from '@attensi/app-launcher'
import { getSubdomainFromPath } from '@attensi/auth'
import { AUTH_URL, BACKEND_URL, ENV, API_TOKEN } from '@/consts'
import { getTokenCompanyNameKey, getAccessToken } from '@/auth'

export const appLauncher = async () => {
  return initAppLauncher({
    env: ENV,
    authUrl: AUTH_URL,
    apiUrl: BACKEND_URL,
    apiToken: API_TOKEN,
    accessToken: await getAccessToken(),
    subdomain: getSubdomainFromPath() as string,
    companyNameKey: await getTokenCompanyNameKey(),
  })
}
